import chatroomReducer from "./reducers";

export default chatroomReducer;